/**
 * Buy Box seller display helpers — same-response identity only.
 * Never invent "Sold by Walmart" from marketplace domain alone.
 */

/**
 * Conservatively map Walmart Inc. seller strings to canonical "Walmart".
 * Third-party marketplace sellers are returned unchanged.
 */
export function canonicalizeBuyBoxSellerName(raw) {
  if (raw == null) return null;
  const text = String(raw).trim();
  if (!text) return null;

  const cleaned = text
    .toLowerCase()
    .replace(/\.com/g, "")
    .replace(/,/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  // Walmart / Walmart.com / Walmart.com USA LLC / Walmart USA LLC
  if (/^walmart(\s+usa)?(\s+llc)?$/.test(cleaned)) {
    return "Walmart";
  }
  return text;
}

/**
 * @returns {string|null} e.g. "Sold by Walmart" or "Sold by Acme Retail LLC"
 */
export function formatBuyBoxSoldBy(rawSeller) {
  const canonical = canonicalizeBuyBoxSellerName(rawSeller);
  if (!canonical) return null;
  return `Sold by ${canonical}`;
}

export function isWalmartBuyBoxSeller(rawSeller) {
  return canonicalizeBuyBoxSellerName(rawSeller) === "Walmart";
}
